const coordinate = (point, key) => {
  const value = point?.[key]
  return Number(typeof value === 'function' ? value.call(point) : value)
}

const rectangleWkt = (east, west, north, south) => {
  const middleLatitude = north - (north - south) / 2
  const middleLongitude = east - (east - west) / 2

  const ne = `${east} ${north}`
  const nese = `${east} ${middleLatitude}`
  const se = `${east} ${south}`
  const sesw = `${middleLongitude} ${south}`
  const sw = `${west} ${south}`
  const swnw = `${west} ${middleLatitude}`
  const nw = `${west} ${north}`
  const nwne = `${middleLongitude} ${north}`

  return `${ne}, ${nese}, ${se}, ${sesw}, ${sw}, ${swnw}, ${nw}, ${nwne}, ${ne}`
}

export const createHeatmapViewportWkt = (northEast, southWest) => {
  const north = coordinate(northEast, 'lat')
  const east = coordinate(northEast, 'lng')
  const south = coordinate(southWest, 'lat')
  const west = coordinate(southWest, 'lng')

  if (![north, east, south, west].every(Number.isFinite)) {
    throw new Error('Heatmap viewport bounds must contain numeric coordinates')
  }

  if (west <= east) {
    return `POLYGON((${rectangleWkt(east, west, north, south)}))`
  }

  // Google normalizes longitudes to [-180, 180]. A west value greater than
  // east means the visible viewport wraps across the international date line.
  const easternHemisphere = rectangleWkt(180, west, north, south)
  const westernHemisphere = rectangleWkt(east, -180, north, south)

  return `MULTIPOLYGON(((${easternHemisphere})), ((${westernHemisphere})))`
}
